import axios from 'axios';

export const fetchSalesVolume = (id: string) => {
  return axios.get(`/api/v1/assets/token/${id}/sales_volume/`).then(({ data }) => data);
};
